import API from '../pages/Api';

// ================= ADMIN SERVICES =================

// १. Registered Users (Pagination sathi 'page' parameter add kela aahe)
export const fetchRegisteredUsers = async (
    page = 1,
    search = ""
) => {
    try {

        const response = await API.get(
            `admin/users/registered/?page=${page}&search=${search}`
        );

        return response.data;

    } catch (error) {

        console.error("Error in fetchRegisteredUsers:", error);

        throw error;

    }
};

// २. Non-Residence Users 
export const fetchNonResidenceUsers = async (
    page = 1,
    search = ""
) => {

    const token = localStorage.getItem("access_token");

    const response = await API.get(
        `/admin/users/non-residence/?page=${page}&search=${encodeURIComponent(search)}`,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );

    return response.data;
};
// ३. Reactivate Course 
export const fetchReactivateUsers = async (page = 1) => {
    try {
        
        const response = await API.get(`admin/users/reactivate/?page=${page}`);
        return response.data;
    } catch (error) {
        console.error("Error in fetchReactivateUsers:", error);
        throw error;
    }
};

// ================= EXPORT ALL SERVICES =================

const Services = {
    fetchRegisteredUsers,
    fetchNonResidenceUsers,
    fetchReactivateUsers,
};

export default Services;